import { render, staticRenderFns } from "./Editor-EventAdmins.vue?vue&type=template&id=0c449b75"
import script from "./Editor-EventAdmins.vue?vue&type=script&lang=ts"
export * from "./Editor-EventAdmins.vue?vue&type=script&lang=ts"
import style0 from "./Editor-EventAdmins.vue?vue&type=style&index=0&id=0c449b75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports